import axios from '@/plugins/axios'

/**
 * 获取一言语录
 * 
 * <p>从一言 API 获取随机语录，用于 Live2D 看板娘的闲置对话。</p>
 * 
 * @returns {Promise} 一言 API 响应
 */
export function getHitokoto() {
  return axios({
    url: 'https://v1.hitokoto.cn/?c=a',
    method: 'GET'
  })
}